import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

import { t } from 'services/translation';
import { lowercase } from 'lib/string_utils';

const InfoBox = styled.div`
  width: calc(100% - 18px);
`;
const Distance = styled.span`
  color: ${Theme.colors.lightText};
`;

export function StoresWithin(props) {
  const { numStores, distance, zipCode, units } = props;
  let stores = numStores === 1 ? t('STORE') : t('STORES');
  stores = stores.toLowerCase();

  return (
    <span>
      <strong>{numStores}</strong> {stores} {lowercase(t('WITHIN'))}{' '}
      <strong>
        {t('DISTANCE_UNIT_OF', '', {
          distance,
          unit: t(units),
        })}{' '}
        {zipCode}
      </strong>
    </span>
  );
}

export function LocationInfo(props) {
  const {
    shopping_center: shoppingCenter,
    distance,
    address,
    city,
    st,
    zip_code: zipCode,
    units,
  } = props;
  return (
    <InfoBox>
      {shoppingCenter && <strong>{shoppingCenter} - </strong>}
      <Distance>
        {distance} {t(units)}
      </Distance>
      <div>{address}</div>
      <div>
        {city}, {st} {zipCode}
      </div>
    </InfoBox>
  );
}
